import { render, staticRenderFns } from "./TeachRoomExt.vue?vue&type=template&id=7c28264e&scoped=true&"
import script from "./TeachRoomExt.vue?vue&type=script&lang=js&"
export * from "./TeachRoomExt.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomExt.vue?vue&type=style&index=0&id=7c28264e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28264e",
  null
  
)

export default component.exports